import { DateTime } from "@/data/util/DateTime";

export class TimePicker {
    private $input: JQuery;
    public onChange?: { (value: string) };

    private currentSeconds?: number;
    private cfg: { showSeconds: boolean };

    constructor($input?: JQuery, cfg?: object, placeHolder?: string) {
        this.$input = $input === undefined ? $('<input type="text" class="form-control" />') : $input;
        if (placeHolder !== undefined) this.$input.attr("placeholder", placeHolder);

        const defaultConfig = {
            defaultTime: false,
            showMeridian: false,
            maxHours: 120,
            showSeconds: true,
            modalBackdrop: true,
        };
        this.cfg = { ...defaultConfig, ...cfg };

        this.$input.timepicker(this.cfg).on("changeTime.timepicker", (e) => {
            let totalSeconds = e.time.hours * 60 * 60;
            totalSeconds += e.time.minutes * 60;
            totalSeconds += e.time.seconds;

            this.currentSeconds = this.roundPrecision(totalSeconds);
        });

        //set time picker to undefined if user clears input field
        this.$input.change(() => {
            if (this.$input.val().length !== 0) return;

            this.currentSeconds = undefined;
            this.$input.timepicker("setTime", null);
        });
    }

    public getValue(): string | undefined {
        if (this.currentSeconds === undefined) return undefined;

        return DateTime.secondsToTimespan(this.currentSeconds);
    }

    public getSeconds(): number | undefined {
        return this.currentSeconds;
    }

    public setValue(value?: string | number): TimePicker {
        if (value === undefined) {
            this.currentSeconds = undefined;
            this.$input.timepicker("setTime", null);
            this.$input.val("");
            return this;
        }

        if (typeof value == "number") {
            this.currentSeconds = value;
            this.$input.timepicker("setTime", DateTime.secondsToTimespan(value));
        } else {
            this.currentSeconds = DateTime.secondsOfTimeSpan(value);
            this.$input.timepicker("setTime", value);
        }

        return this;
    }

    public setError(hasError: boolean): TimePicker {
        if (hasError) this.$input.addClass("is-invalid");
        else this.$input.removeClass("is-invalid");

        return this;
    }

    public setDisabled(isDisabled: boolean): TimePicker {
        this.$input.prop("disabled", isDisabled);

        return this;
    }

    public renderTo($element: JQuery): TimePicker {
        this.$input.appendTo($element);
        return this;
    }

    public reset(): TimePicker {
        this.$input.val("");
        return this;
    }

    public static createFromInput($input: JQuery, cfg?: object): TimePicker {
        return new TimePicker($input, cfg);
    }

    private roundPrecision(seconds: number): number {
        if (!this.cfg.showSeconds) return Math.floor(seconds / 60) * 60;

        return seconds;
    }
}
